import {isNil} from 'ramda';

import {CustomerResponseBodyV2} from '@dms/api/customer';
import {ConsentRecipient} from '@dms/api/shared';
import {getCustomerName} from '@dms/shared';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

export type ConsentRecipientOption = {
  label: string;
  value: string;
  institutionTypes: string[];
};

/**
 * Builds the third party options of a consent type. The current recipient is kept as an option
 * even when it is no longer an eligible customer, so an edited consent type still shows it.
 */
export const getConsentRecipientOptions = (
  customers: CustomerResponseBodyV2[] | Nullish,
  recipient: ConsentRecipient | Nullish
): ConsentRecipientOption[] => {
  const customerOptions = (customers ?? []).map((customer) => ({
    label: getCustomerName(customer) ?? EMPTY_PLACEHOLDER,
    value: customer.id,
    institutionTypes: customer.institutions ?? [],
  }));

  const isRecipientListed = customerOptions.some(
    (option) => option.value === recipient?.customerId
  );

  return isNil(recipient) || isRecipientListed
    ? customerOptions
    : [
        ...customerOptions,
        {
          label: recipient.name ?? EMPTY_PLACEHOLDER,
          value: recipient.customerId,
          institutionTypes: recipient.institutionTypes,
        },
      ];
};
